import react, { useState, useEffect } from "react"
import {
	Avatar,
	Box,
	Typography,
	Button,
	IconButton,
	Popover,
	Divider,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	useTheme
} from "@mui/material";
import { getPublicS3Url } from "../../utils/s3PublicUrl";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { clearUserData } from "../../features/user/UserSlices";

const ProfileMenu = () => {

	const [profileAnchor, setProfileAnchor] = useState(null);
	const [isDrawerOpen, setIsDrawerOpen] = useState(true)
	const [logoutDialogOpen, setLogoutDialogOpen] = useState(false)
	const userDetails = useSelector(
		(state) => state.user.userDetails
	);


	const location = useLocation();
	const isDastak = location.pathname.includes("/dastak");
	const theme = useTheme()
	const dispatch = useDispatch()
	const navigate = useNavigate()

	const handleDrawerOpen = () => setIsDrawerOpen(true);
	const handleDrawerClose = () => setIsDrawerOpen(false);

	const handleProfileClick = (event) => setProfileAnchor(event.currentTarget);
	const handleProfileClose = () => setProfileAnchor(null);

	const handleLogout = () => {
		localStorage.clear();
		dispatch(clearUserData());
		navigate(isDastak?"/dastak/landingpage" : "/");
	};

	 const goToProfile = () => {
    const userId = localStorage.getItem("userId");
    navigate((`/dastak/profile/${userId}`), {
      state: { mode: "view", navigateFrom: "viewAccount" },
    });
	// setIsDrawerOpen(false);
	setProfileAnchor(false);
  };


	const user = {
		userFirstName:
			userDetails?.userFirstName || "",
		userLastName:
			userDetails?.userLastName || "",
		profilePicUrl:
			getPublicS3Url(
				userDetails?.userImageURL
			) || "",
		emailId:
			userDetails?.emailId || "",
	};

	return <>
		<Box
			sx={{
				display: "flex",
				alignItems: { xs: "left", sm: "center" },
				gap: { xs: 1, sm: 1, md: 2, lg: 2 },
			}}
		>
			<IconButton sx={{ p: 0.5 }} onClick={handleProfileClick}>
				<Avatar
					src={user.profilePicUrl}
					sx={{
						width: 38,
						height: 38,
						bgcolor: theme.palette.secondary.main,
						color: theme.palette.primary.main,
						fontWeight: 600,
					}}
				>
					{user.userFirstName ? (
						user.userFirstName.charAt(0).toUpperCase()
					) : (
						<PersonOutlineIcon />
					)}
				</Avatar>
			</IconButton>

			<Popover
				open={Boolean(profileAnchor)}
				anchorEl={profileAnchor}
				onClose={handleProfileClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				transformOrigin={{ vertical: "top", horizontal: "right" }}
				PaperProps={{
					sx: {
						borderRadius: 2,
						mt: 1.2,
						width: 280,
						boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
					},
				}}
			>
				<Box sx={{ display: "flex", alignItems: "center", px: 2, py: 2 }}>
					<Avatar
						src={user.profilePicUrl}
						sx={{
							width: 48,
							height: 48,
							mr: 2,
							bgcolor: theme.palette.secondary.main,
							color: theme.palette.primary.main,
							fontWeight: 600,
						}}
					>
						{user.userFirstName ? (
							user.userFirstName.charAt(0).toUpperCase()
						) : (
							<PersonOutlineIcon />
						)}
					</Avatar>
					<Box>
						<Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
							{user.userFirstName} {user.userLastName}
						</Typography>
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{ wordBreak: "break-word" }}
						>
							{user.emailId}
						</Typography>

						<Box
							sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}
						>
							<Button
								variant="contained"
								size="small"
								onClick={goToProfile}
								sx={{ textTransform: "none", borderRadius: 1.5 }}
							>
								View Account
							</Button>
							<Button
								variant="outlined"
								size="small"
								onClick={() => setLogoutDialogOpen(true)}
								sx={{ textTransform: "none", borderRadius: 1.5 }}
							>
								Logout
							</Button>

							<Dialog
								open={logoutDialogOpen}
								onClose={() => setLogoutDialogOpen(false)}
							>
								<DialogTitle>Confirm Logout</DialogTitle>
								<DialogContent>
									Are you sure you want to logout?
								</DialogContent>
								<DialogActions>
									<Button onClick={() => setLogoutDialogOpen(false)}>
										Cancel
									</Button>
									<Button
										variant="outlined"
										sx={{ textTransform: "none", borderRadius: 1.5 }}
										onClick={() => {
											setLogoutDialogOpen(false);
											handleLogout();
										}}
									>
										Logout
									</Button>
								</DialogActions>
							</Dialog>
						</Box>
					</Box>
				</Box>
				<Divider />
			</Popover>
		</Box>
	</>
}

export default ProfileMenu;
